import Section from './ColorVisualizerSection'
import isEmpty from './ColorVisualizerIsEmpty'

export default { Section, isEmpty }
